import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../lib/cn.js';
export function Card({ className, children, onActivate, activateLabel, ...props }) {
    if (onActivate) {
        return (_jsx("button", { type: "button", onClick: onActivate, "aria-label": activateLabel, className: cn('block w-full rounded-md border border-border-decorative bg-surface-base p-4 text-left shadow-elevation-1', 'transition-colors duration-fast hover:bg-surface-hover', 'focus-visible:outline-none focus-visible:shadow-focus', className), children: children }));
    }
    return (_jsx("div", { className: cn('rounded-md border border-border-decorative bg-surface-base p-4 shadow-elevation-1', className), ...props, children: children }));
}
//# sourceMappingURL=Card.js.map